<template>
  <div>
    <el-dialog title="" :visible.sync="isShowadmin" width="30%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Add Category
        </h3></template
      >
      <div class="px-4">
        <div class="">
          <label>Category Name</label>
          <el-input
            placeholder="Please input"
            class="w-full mt-2"
            v-model="input"
          ></el-input>
          <p v-if="submitted == true" class="fsize12 text-danger">
            {{ input === "" ? "This Field is required" : "" }}
          </p>
        </div>

        <div class="mt-4">
          <label>Status</label>
          <div class="flex items-center gap-2 mt-2">
            <el-radio-group v-model="radio">
              <el-radio :label="true">Active</el-radio>
              <el-radio :label="false">Inactive</el-radio>
            </el-radio-group>
          </div>
          <p v-if="submitted == true" class="fsize12 text-danger">
            {{ radio === "" ? "This Field is required" : "" }}
          </p>
        </div>
        <div class="mt-8 flex justify-center w-full">
          <el-button
            variant="primary"
            class="px-12 py-3 rounded-lg w-full text-white bg-primary cursor-pointer"
            @click="createCategory"
            v-if="submitButton"
          >
            Submit</el-button
          >
          <el-button
            variant="primary"
            class="px-12 py-3 rounded-lg w-full text-white bg-primary cursor-pointer"
            @click="updateCategory(editCategory._id)"
            v-if="updateButton"
          >
            Update</el-button
          >
        </div>
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Category
          </h2>
        </div>
      </div>
    </div>
    <div class="fixed-top menucontrol-scroll p-8 bg-white">
      <div class="w-full flex justify-end">
        <el-button
          color="primary"
          @click="onClick"
          class="px-12 py-4 rounded-lg text-white bg-primary cursor-pointer"
          >Add Category</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-colorpd"
        border
      >
        <el-table-column label="Sr No." type="index" width="60px">
        </el-table-column>

        <el-table-column
          prop="categoryName"
          label="Category"
          min-width="250px"
        ></el-table-column>
        <el-table-column label="Status" min-width="50px">
          <template slot-scope="scope">
            <P
              :class="`${
                scope.row.isActive === true ? 'text-success' : 'text-danger'
              }`"
              >{{ scope.row.isActive === true ? "Active" : "InActive" }}</P
            ></template
          >
        </el-table-column>
        <el-table-column label="Options" min-width="40px">
          <template slot-scope="scope">
            <div class="flex gap-1 items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="editCategoryData(scope.row._id)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="deleteCategory(scope.row._id)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="w-full flex justify-end mt-6">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="
            (value) => {
              currentPage = value;
              getCategory();
            }
          "
          :per-size="perPage"
          :total="totalUsers"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      radio: ref(""),
      number: 0,
      input: "",
      editCategory: "",
      isShowadmin: false,
      submitButton: false,
      updateButton: false,
      submitted: false,
      tableData: [],
      totalUsers: 0,
      currentPage: 1,
      perPage: 10,
    };
  },
  watch: {
    input() {
      this.whitespaceRemove();
    },
  },
  methods: {
    async getCategory() {
      let data = await this.$store.dispatch("blogs/getCategories", {
        perPage: this.perPage,
        page: this.currentPage,
      });
      this.tableData = data.data.category;
      this.totalUsers = data.data.categoryLength;
    },
    onClick() {
      this.input = "";
      this.radio = "";
      this.submitted = false;
      this.updateButton = false;
      this.isShowadmin = true;
      this.submitButton = true;
    },
    async createCategory() {
      this.submitted = true;
      let payload = {
        categoryName: this.input,
        isActive: this.radio,
      };

      if (this.input !== "" && this.radio !== "") {
        await this.$store.dispatch("blogs/createCategories", payload);
        this.isShowadmin = false;
        this.input = "";
        this.radio = "";
        this.getCategory();
      }
    },
    async editCategoryData(id) {
      this.isShowadmin = true;
      this.submitButton = false;
      this.updateButton = true;
      let index = this.tableData.findIndex((x) => x._id === id);
      this.editCategory = this.tableData[index];
      this.input = this.editCategory.categoryName;
      this.radio = this.editCategory.isActive;
      console.log(this.editCategory.isActive, "radio");
    },
    async updateCategory(id) {
      let payload = {
        _id: id,
        categoryName: this.input,
        isActive: this.radio,
      };
      await this.$store.dispatch("blogs/updateCategories", payload);
      this.getCategory();
      this.isShowadmin = false;
      this.input = "";
      this.radio = "";
    },

    async deleteCategory(id) {
      await this.$store.dispatch("blogs/deleteCategories", { _id: id });
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : (this.currentPage = 1);
      this.getCategory();
    },
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.input = this.input ? this.input.trimStart() : "";
      });
    },
  },

  computed: {
    ...mapState("blogs", ["categories"]),
  },

  mounted() {
    this.getCategory();
  },
};
</script>
